import { OrganizationDetailContent } from "../../content/organization/organizationDetail";
import { Layout } from "../../layout/page";

export function OrganizationDetail() {
  return (
    <Layout>
      <OrganizationDetailContent />
    </Layout>
  );
}
